import {useMemo} from "react";
import SentryEchart from "../../../../../../../../components/echarts/sentry-echart.jsx";
import {
    DASHBOARD_LAST_POINT_SERIES_STYLE,
    DASHBOARD_LINE_CHART_GRID,
    DASHBOARD_LINE_CHART_TOOLTIP,
    DASHBOARD_LINE_CHART_X_AXIS,
    DASHBOARD_LINE_CHART_Y_AXIS,
    DASHBOARD_LINE_SERIES_STYLE,
} from "../../../../../../dashboard-wall/utils/line-chart-styles.js";

export default function ActivationTimeline({data}) {
    const timeline = data?.alarms?.timeline;

    const timelineChart = useMemo(() => {
        const chartData = Array.isArray(timeline)
            ? timeline.map(item => ({
                label: item.label ?? "",
                value: Number(item.qty) || 0,
            }))
            : [];
        const currentWeekday = ["dom", "seg", "ter", "qua", "qui", "sex", "sab"][new Date().getDay()];
        const currentDayPoint = chartData.find(point =>
            point.label
                .trim()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .startsWith(currentWeekday)
        );

        return {
            grid: DASHBOARD_LINE_CHART_GRID,
            tooltip: {
                ...DASHBOARD_LINE_CHART_TOOLTIP,
                formatter: params => {
                    const [point] = params;
                    return `${point.axisValue}<br/>${point.marker} Acionamentos: <b>${point.value}</b>`;
                },
            },
            xAxis: {
                ...DASHBOARD_LINE_CHART_X_AXIS,
                data: chartData.map(item => item.label),
                axisLabel: {
                    ...DASHBOARD_LINE_CHART_X_AXIS.axisLabel,
                    interval: 0,
                },
            },
            yAxis: DASHBOARD_LINE_CHART_Y_AXIS,
            series: [
                {
                    ...DASHBOARD_LINE_SERIES_STYLE,
                    name: "Acionamentos",
                    data: chartData.map(item => item.value),
                },
                {
                    ...DASHBOARD_LAST_POINT_SERIES_STYLE,
                    name: "Dia atual",
                    data: currentDayPoint ? [[currentDayPoint.label, currentDayPoint.value]] : [],
                },
            ],
        };
    }, [timeline]);

    return (
        <article className="col-span-4 box-border h-full min-h-0 min-w-0 w-full">
            <SentryEchart
                className="h-full min-h-0 w-full"
                option={timelineChart}
                title="Quantidade de acionamentos por dia"
            />
        </article>
    )
}
